import Vue from "vue";
import VueRouter from "vue-router";
import tools from "@/api/tools";
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
const routes = [
  {
    path: "/",
    redirect: "/app/index",
  },
  {
    path: "/app/index",
    name: "index",
    component: () => import("@/pages/index"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/my",
    name: "my",
    component: () => import("@/pages/my"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/policysList",
    name: "policysList",
    component: () => import("@/pages/listPages/policysList"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/bxAgentList",
    name: "bxAgentList",
    component: () => import("@/pages/listPages/bxAgentList"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/customerList",
    name: "customerList",
    component: () => import("@/pages/listPages/customerList"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/followUp",
    name: "followUp",
    component: () => import("@/pages/listPages/followUp"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/saveUser",
    name: "saveUser",
    component: () => import("@/pages/saveUser"),
    meta: {
      title: "同频赋能宝"
    }
  },
  {
    path: "/app/login",
    name: "login",
    component: () => import("@/pages/login"),
    meta: {
      title: "同频赋能宝"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  if(to.name != 'login' && to.name != 'saveUser' && !localStorage.h5_token){
    next('/app/login');
    return
  }
  if (to.meta.title) {
    tools.setWebTitle(to.meta.title);
  }
  next();
});
router.afterEach((to, from) => {
  // 处理ios分享不支持history问题
  if (tools.isIOS() && !window.entryUrl) {
    window.entryUrl = location.href.split("#")[0];
  }
});
export default router;
